import { ViewModel,View, Component } from "binder"
import { getAsNumber } from "../utilities";
import  { MultiLineTextInputView } from "./multiLineTextInput-view"

export class MultiLineTextInputViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isreadonly = false;
        this.disabled = false;
        this.isnumeric=false;
        this.cancopy = false;
        this.rowsheight = 5;
    }
    GetDefaultView(): View <ViewModel> {
        return new MultiLineTextInputView();
    }
    public getTypeId(): string {
        return "VM-76602049-D8FE-4FB8-85E4-A23FF5544099"
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    public set isreadonly(v: boolean) { this._isreadonly = v; } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set isnumeric(v: boolean) { this._isnumeric = v; } public get isnumeric(): boolean { return this._isnumeric;} private _isnumeric: boolean;
    public set maxlength(v: number) { this._maxlength = getAsNumber(v,true); } public get maxlength(): number { return this._maxlength;} private _maxlength: number;
    
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    public set min(v: number) { this._min = v; } public get min(): number { return this._min;} private _min: number;
    public set max(v: number) { this._max = v; } public get max(): number { return this._max;} private _max: number;
    public set placeholder(v: string) { this._placeholder = v; } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set slots(v: string) { this._slots = v; } public get slots(): string { return this._slots;} private _slots: string;
    public set accepts(v: string) { this._accepts = v; } public get accepts(): string { return this._accepts;} private _accepts: string;
    public set cancopy(v: boolean) { this._cancopy = v; } public get cancopy(): boolean { return this._cancopy;} private _cancopy: boolean;
    public set isShowingCopiedMessage(v: boolean) { this._isShowingCopiedMessage = v; } public get isShowingCopiedMessage(): boolean { return this._isShowingCopiedMessage;} private _isShowingCopiedMessage: boolean;
    public set rowsheight(v: number) { this._rowsheight = getAsNumber(v,true); } public get rowsheight(): number { return this._rowsheight;} private _rowsheight: number;
    public set caretposition(v: number) { this._caretposition = v; } public get caretposition(): number { return this._caretposition;} private _caretposition: number;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;

    showCopiedMessage() {
        setTimeout(()=>{
            this.isShowingCopiedMessage = true;
            setTimeout(()=>this.isShowingCopiedMessage = false,3000);
    
        },500);
    }
}
